import { render, staticRenderFns } from "@/manager/purchase/views/convocation-detail/convocation-detail.pug?vue&type=template&id=a73af452&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/manager/purchase/views/convocation-detail/convocation-detail.scss?vue&type=style&index=0&id=a73af452&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a73af452",
  null
  
)

export default component.exports